export const DialogMode = {
  NONE: 0,
  FINANCE: 1,
  SALES: 2,
}

export const exampleConstant = () => {}

export const passwordHelperText =
  'Must be at least 8 characters and contain one uppercase letter, one lowercase letter, one number and one special character (e.g., ! # $ %)'

export const publicRoutes = [
  // routes.auth,
  // routes.publicBusiness,
  '/equifax/business/validate-callback/',
  '/equifax/business/validate-start/',
  // routes.admin,
]

export const AVAILABLE_TRIAL_DAYS = 7
export const DATE_FORMAT = 'MM/DD/YYYY'

export const daySpanOptions = [30, 60, 90, 180, 360]

export const getCurrentDate = () => {
  const date = new Date()
  const day = date.getDate()
  const month = date.getMonth() + 1
  const year = date.getFullYear()

  const fullDate = `${month}/${day}/${year}`
  return fullDate
}

export const PRICING_CARD_INFO = {
  premium: {
    type: 'premium',
    title: 'Premium Membership',
    buttonText: 'Get Started',
    pricing: {
      period: 'monthly',
      dollarAmount: 49,
      centAmount: 99,
    },
    alternativePricing: {
      period: 'annually',
      dollarAmount: 479,
      centAmount: 90,
    },
    discountInPercent: 20,
    messages: [
      'Information and access to over 100M pre-verified businesses',
      'Access to your latest business credit scores',
      'Members-only webinars,events,meetups and discounted resources',
      'Connect apps and customize your own dashboard',
      'Upload,store and share your key business artifacts',
      'Claim your business and build trusted partnerships faster the verified by Markaaz bagde',
      'COMING SOON- Get Prepaid Options',
    ],
  },
  free: {
    type: 'free',
    title: 'Free',
    pricing: {
      period: 'monthly',
      dollarAmount: 0,
    },
    messages: [
      'Search our network of over 100M businesses on Markaaz',
      'Limited information on partners and business in the directory',
    ],
    buttonText: 'Open Dashboard',
  },
}
